import { toast } from 'react-toastify';
import { faqUploadFun } from '../../../api/addDataAPI';
import errorHandle from '../../../utils/errorHandle';

//Add faq
export const addFaqSubmit = async (faqData, setLoading) => {
    try {
        if (3 > faqData.question.length || faqData.question.length > 50) {
            toast.error('Question error');
            return;
        } else if (50 > faqData.answer.length || faqData.answer.length > 1000) {
            toast.error('Answer error');
            return;
        }
        const res = await faqUploadFun(faqData);
        if (res.status === 200) {
            toast.success('FAQ created successfully');
            return res.status;
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
